import assetPath from '/app/packages/lebenslauf/components/src/assets/open-sans-regular.woff';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')